<template>
  <li
    class="nav-item px-2 text"
    style="text-align: left"
    :class="{ 'menu-open': seccion_aux == 'charter' }"
  >
    <a href="#" class="nav-link">
      <i class="nav-icon fas fa-ship"></i>
      <p>Charter<i class="fas fa-angle-left right"></i></p>
    </a>
    <ul class="nav nav-treeview">
      <!-- Planificación Anual -->
      <li class="nav-item" v-if="showPlanificacionAnual">
        <router-link class="nav-link" to="/charter/planificacion_anual">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Planificación Anual</p>
        </router-link>
      </li>

      <!-- Planificación Anual -->
      <li class="nav-item" v-if="showPlanificacionSemanal">
        <router-link class="nav-link" to="/charter/planificacion_semanal">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Planificación Semanal</p>
        </router-link>
      </li>

      <!-- Servicios -->
      <li class="nav-item" v-if="showServicios">
        <router-link class="nav-link" to="/charter/servicios">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Servicios</p>
        </router-link>
      </li>

      <!-- Declaración por Nave -->
      <li class="nav-item" v-if="showDeclaracionPorNave">
        <router-link class="nav-link" to="/charter/declaracion_por_nave">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Declaración por Nave</p>
        </router-link>
      </li>

      <!-- Itinerarios -->
      <li class="nav-item" v-if="showItinerarios">
        <router-link class="nav-link" to="/charter/itinerarios">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Itinerarios</p>
        </router-link>
      </li>

            <!-- Tarifas -->
      <li
        class="nav-item"
        v-if="showSi"
      >
        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Shipping Instructions <i class="fas fa-angle-left right"></i></p>
        </a>

        <ul class="nav nav-treeview">
          <li class="nav-item" v-if="showPorEnviar">
            <!-- Contratos -->
            <router-link class="nav-link" to="/charter/si/por-enviar">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Por Enviar</p>
            </router-link>
          </li>

          <li class="nav-item" v-if="showEnviadas">
            <!-- Contratos -->
            <router-link class="nav-link" to="/charter/si/enviadas">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Enviadas</p>
            </router-link>
          </li>

          <li class="nav-item" v-if="showTemplates">
            <!-- Contratos -->
            <router-link class="nav-link" to="/charter/si/templates">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Templates</p>
            </router-link>
          </li>
        </ul>
      </li>

      <li class="nav-item" v-if="showCharterReporte">
        <router-link class="nav-link" to="/charter/reporte-general-charter">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p> Reporte General Charter </p>
        </router-link>
      </li>

    </ul>
  </li>
</template>

<script>
/**
 * @author Miguel González.
 * @description modify role structure. 
 * last modified 18-04-2023 17:25
 */
// Vuex
import { mapState } from "vuex";

export default {
  data() {
    return {
      current_url: "",
      seccion_aux: "",
      showServicios : false ,
      showGeneral : false ,
      showSi        : true,
      showPorEnviar : true,
      showEnviadas  : true,
      showTemplates  : true,
      showCharterReporte : false
    };
  },
  computed: {
    ...mapState(["url_actual", "seccion_actual", "sub_seccion_actual"]),
    ...mapState("seccionesLineas", [
      "isPlanificacionAnual",
      "isPlanificacionMensual",
      "isServicios",
      "isDeclaracionPorNave",
      "isGeneral",
      "isItinerarios",
    ]),
  },

  watch: {
    url_actual: function (_new) {
      this.seccion_aux = _new.split("/")[1];
    },
  },
  methods: {
    superAdmin(){
      this.showPlanificacionAnual = true;
      this.showPlanificacionSemanal = true;
      this.showServicios = true;
      this.showDeclaracionPorNave = true;
      this.showGeneral = true;
      this.showItinerarios = true;
      this.showSubItinerarios = true;
      this.showBuscarItinerarios = true;

      this.showSi = true;
      this.showPorEnviar = true;
      this.showEnviadas  = true;
      this.showTemplates = true;
      this.showCharterReporte  = true;
    }
  },
  created(){
    if(JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') this.superAdmin();
    const charterRoleStructure = JSON.parse(localStorage.getItem('roleStructure')).find(({idModule}) => idModule === 2);
    if(charterRoleStructure){
      charterRoleStructure.sections.map(({ idSection, subSections }) => {
        switch (idSection) {
          case 27: this.showPlanificacionAnual = true; break;
          case 28: this.showPlanificacionSemanal = true; break;
          case 29: this.showServicios = true; break;
          case 30: this.showDeclaracionPorNave = true; break;
          case 31: this.showGeneral = true; break;
          case 32: //itinerarios
            this.showItinerarios = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 225: this.showSubItinerarios = true; break;
                case 226: this.showBuscarItinerarios = true; break;
                default: break;
              }
            });
            break;
          case 256: //SI
            this.showSi = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 257: this.showPorEnviar = true; break;
                case 258: this.showEnviadas = true; break;
                case 260: this.showTemplates = true; break;
                default: break;
              }
            });
            break;
          case 259: this.showCharterReporte = true; break;
          default: break;
        }
      });
    }
    const charterUserStructure = JSON.parse(localStorage.getItem('userStructure')).find(({idModule}) => idModule === 2);
    
    if(charterUserStructure){
      charterUserStructure.sections.map(({ idSection, subSections }) => {
        switch (idSection) {
          case 27: this.showPlanificacionAnual = true; break;
          case 28: this.showPlanificacionSemanal = true; break;
          case 29: this.showServicios = true; break;
          case 30: this.showDeclaracionPorNave = true; break;
          case 31: this.showGeneral = true; break;
          case 32: //itinerarios
            this.showItinerarios = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 225: this.showSubItinerarios = true; break;
                case 226: this.showBuscarItinerarios = true; break;
                default: break;
              }
            });
            break;
          case 256: //SI
            this.showSi = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 257: this.showPorEnviar = true; break;
                case 258: this.showEnviadas = true; break;
                case 260: this.showTemplates = true; break;
                default: break;
              }
            });
            break;
          case 259: this.showCharterReporte = true; break;
          default: break;
        }
      });
    }
  }
};
</script>

<style>
.subMenu {
  margin-left: 8px !important;
}
</style>
